import GlobalModals from './GlobalModals';

export default GlobalModals;
